<template>
    <div v-if="title" :class="['gray-panel', wrapperClass]">
        <h2 class="title">{{ title }}</h2>
        <div class="content bg-white">
            <slot/>
            {{ content }}
        </div>
    </div>
</template>
  
<script>
export default {
    name: 'GrayPanel',
    props: {
        title: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        },
        wrapperClass: {
            type: String,
            default: ""
        }
    }
}
</script>
<style lang="scss" scoped>
@import "./styles.scss";
</style>  